import { createAction, createSlice } from "@reduxjs/toolkit";
import { Document } from "../../@types/document";
import { createArchive } from "./actions/createArchiveBasic";
import { createDocument } from "./actions/createDocumentBasic";
import { uploadArchive } from "./actions/uploadArchive";

interface DocumentCreateState {
  createArchiveStatus: string;
  createDocumentStatus: string;
  uploadArchiveStatus: string;
  document: Document;
}

const initialState = {
  createArchiveStatus: "",
  createDocumentStatus: "",
  uploadArchiveStatus: "",
  document: {} as Document,
} as DocumentCreateState;

export const setCreateDocumentStatus = createAction<string>("SET_CREATE_DOCUMENT_STATUS");
export const setCreateArchiveStatus = createAction<string>("SET_CREATE_ARCHIVE_STATUS");
export const setUploadArchiveStatus = createAction<string>("SET_UPLOAD_ARCHIVE_STATUS");

const documentCreateSlice = createSlice({
  name: "documentCreate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setCreateArchiveStatus, (state, { payload }) => {
        state.createArchiveStatus = payload;
      })
      .addCase(setCreateDocumentStatus, (state, { payload }) => {
        state.createDocumentStatus = payload;
      })
      // Create Archive
      .addCase(createArchive.pending, (state) => {
        state.createArchiveStatus = "pending";
      })
      .addCase(createArchive.fulfilled, (state, { payload }) => {
        state.createArchiveStatus = "fulfilled";
        state.document = {
          ...state.document,
          archive: payload,
          archiveFilename: (payload || {}).filename,
        };
      })
      .addCase(createArchive.rejected, (state) => {
        state.createArchiveStatus = "rejected";
      })
      // Create Documents
      .addCase(createDocument.pending, (state) => {
        state.createDocumentStatus = "pending";
      })
      .addCase(createDocument.fulfilled, (state, { payload }) => {
        // state.document = { ...payload };
        state.createDocumentStatus = "fulfilled";
      })
      .addCase(createDocument.rejected, (state) => {
        state.createDocumentStatus = "rejected";
      })
      // Upload Archive
      .addCase(uploadArchive.pending, (state) => {
        state.uploadArchiveStatus = "pending";
      })
      .addCase(uploadArchive.rejected, (state) => {
        state.uploadArchiveStatus = "rejected";
      })
      .addCase(uploadArchive.fulfilled, (state, { payload }) => {
        state.uploadArchiveStatus = "fulfilled";
        state.document = {
          ...state.document,
          archive: payload,
          archiveFilename: payload.filename,
        };
      });
  },
});

export const documentCreate = documentCreateSlice.reducer;
